<div class="header" [style.width.px]="rowWidth()">
  <div class="row" #row [style.grid-template-columns]="gridTemplateColumnsRow()">
    @if (leftGridTemplateColumns(); as styles) {
      <div class="cells sticky slot-left" [style.grid-template-columns]="styles">
        @for (column of leftColumns(); track column.name; let index = $index) {
          <ng-container
            [ngTemplateOutlet]="getTemplate(column.type)"
            [ngTemplateOutletContext]="{ column, index, columnsCount: allColumnsCount() }"
          />
        }
      </div>
    }
    <div class="cells" [style.grid-template-columns]="gridTemplateColumns()">
      @for (column of columns(); track column.name; let index = $index) {
        <ng-container
          [ngTemplateOutlet]="getTemplate(column.type)"
          [ngTemplateOutletContext]="{
            column,
            index: index + leftColumnsCount(),
            columnsCount: allColumnsCount(),
          }"
        />
      }
    </div>
    @if (rightGridTemplateColumns(); as styles) {
      <div class="cells sticky slot-right" [style.grid-template-columns]="styles">
        @for (column of rightColumns(); track column.name; let index = $index) {
          <ng-container
            [ngTemplateOutlet]="getTemplate(column.type)"
            [ngTemplateOutletContext]="{
              column,
              index: index + leftColumnsCount() + columnsCount(),
              columnsCount: allColumnsCount(),
            }"
          />
        }
      </div>
    }
  </div>
</div>

<ng-template #selectTemplate>
  <div class="cell select-cell" #cell role="columnheader" [attr.data-col-name]="selectColumnName()">
    <div class="header-cell-container">
      @if (hasSelection()) {
        <blaze-checkbox
          class="with-theme"
          data-cy="TableElement:SelectAll"
          [checked]="isAnyRowSelected() && isAllSelected()"
          [indeterminate]="isAnyRowSelected() && !isAllSelected()"
          (change)="$event ? toggleSelectAll.emit() : null"
        />
      }
    </div>
  </div>
</ng-template>

<ng-template #actionsTemplate>
  <div
    class="cell actions-cell"
    #cell
    #actions
    role="columnheader"
    [attr.data-col-name]="actionsColumnName()"
  >
    <div class="header-cell-container justify-center text-center">Actions</div>
  </div>
</ng-template>

<ng-template #columnTemplate let-column="column" let-index="index" let-columnsCount="columnsCount">
  <div
    class="cell cell-align-{{ column.def?.align }}"
    #cell
    role="columnheader"
    [attr.data-col-name]="column.name"
  >
    <be-resize-column
      class="resize-column interactive"
      [tableWidth]="tableWidth()"
      [columnName]="column.name"
      [displayedColumns]="displayedColumns()"
      [displayedColumnsDef]="displayedColumnsDef()"
      [allColumns]="allColumns()"
      [cell]="cell"
      [row]="row"
      (resizeColumn)="onResize($event)"
    />
    <div
      class="header-cell-container"
      [blazeTooltip]="column.def?.label"
      [mat-sort-header]="column.name"
    >
      {{ column.def?.label }}
    </div>
  </div>
</ng-template>
